export default __webpack_public_path__ + "static/mapbackground-e14cd004c3d58816cb330125a5dd6321.webp";